import { IGAO } from '../../../igao'

export function CSR (): JSX.Element {
  return (
    <div className='main'>
      <IGAO
        path='csr'
        withTopMargin={false}
      />
    </div>
  )
}
